<template>
  <div>
    <el-card shadow="hover" v-loading="loading">
      <div slot="header" class="header">
        <div class="title">
          <span>用户</span>
          <el-tag v-if="total" size="mini" type="info" style="margin-left:8px;">{{ total }} 人</el-tag>
        </div>
        <div class="actions">
          <el-input
            size="small"
            placeholder="搜索 openid/昵称/手机号"
            style="width: 240px;"
            v-model.trim="keyword"
            clearable
            @keyup.enter.native="onSearch"
          />
          <el-button size="small" icon="el-icon-search" @click="onSearch">搜索</el-button>
          <el-button size="small" icon="el-icon-refresh" @click="refresh">刷新</el-button>
        </div>
      </div>

      <el-table :data="list" border stripe highlight-current-row empty-text="暂无用户">
        <el-table-column prop="id" label="ID" width="90" />
        <el-table-column prop="nick_name" label="昵称" width="180" />
        <el-table-column prop="phone_number" label="手机号" width="150" />
        <el-table-column prop="openid" label="openid" min-width="260" show-overflow-tooltip />
        <el-table-column prop="created_at" label="创建时间" width="170">
          <template slot-scope="scope">
            {{ formatTime(scope.row.created_at) }}
          </template>
        </el-table-column>
        <el-table-column prop="updated_at" label="更新时间" width="170">
          <template slot-scope="scope">
            {{ formatTime(scope.row.updated_at) }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="150" fixed="right">
          <template slot-scope="scope">
            <el-button type="primary" size="mini" @click="openAssign(scope.row)">分配柜子</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div style="height: 12px;"></div>
      <el-pagination
        background
        layout="total, prev, pager, next, jumper"
        :current-page.sync="page"
        :page-size="pageSize"
        @current-change="refresh"
        :total="total"
      />
    </el-card>

    <el-dialog
      title="分配智能柜权限"
      :visible.sync="assignVisible"
      width="720px"
      :close-on-click-modal="false"
    >
      <div class="assign-header">
        <div>
          用户：<b>{{ currentUser ? (currentUser.nick_name || currentUser.openid) : "" }}</b>
          <span v-if="currentUser">（ID: {{ currentUser.id }}）</span>
        </div>
        <div class="assign-actions">
          <el-input
            size="small"
            placeholder="筛选机构名称"
            style="width: 240px;"
            v-model.trim="treeFilter"
            clearable
          />
          <el-button size="small" @click="toggleExpand">{{ expandAll ? "收起" : "展开" }}</el-button>
          <el-button size="small" @click="checkAll">全选</el-button>
          <el-button size="small" @click="clearChecked">清空</el-button>
        </div>
      </div>

      <div v-loading="assignLoading" element-loading-text="加载中…" style="min-height: 200px;">
        <el-empty v-if="!assignLoading && !treeData.length" description="暂无智能柜数据" />
        <el-tree
          v-show="!assignLoading && treeData.length"
          ref="treeRef"
          :data="treeData"
          :props="treeProps"
          node-key="key"
          show-checkbox
          :default-expand-all="expandAll"
          :expand-on-click-node="false"
          :filter-node-method="filterNode"
          :render-content="renderNode"
          style="max-height: 420px; overflow:auto;"
        />
      </div>

      <div class="assign-footer-tip">勾选机构可一键选择该机构下所有柜子</div>

      <span slot="footer">
        <el-button @click="assignVisible=false">取消</el-button>
        <el-button type="primary" :loading="savingAssign" @click="saveAssign">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getUsers, getCabinetTree, getUserCabinetIds, saveUserCabinets } from "@/api";

export default {
  name: "User",
  data() {
    return {
      loading: false,
      list: [],
      total: 0,
      page: 1,
      pageSize: 20,
      keyword: "",

      assignVisible: false,
      assignLoading: false,
      savingAssign: false,
      currentUser: null,
      treeData: [],
      treeFilter: "",
      expandAll: true,
      treeProps: {
        children: "children",
        label: "label"
      }
    };
  },
  mounted() {
    this.refresh();
  },
  watch: {
    treeFilter(val) {
      if (this.$refs.treeRef) this.$refs.treeRef.filter(val);
    }
  },
  computed: {},
  methods: {
    formatTime(ts) {
      const t = Number(ts || 0) * 1000;
      if (!t) return "-";
      const d = new Date(t);
      const pad = (n) => String(n).padStart(2, "0");
      return (
        d.getFullYear() +
        "-" +
        pad(d.getMonth() + 1) +
        "-" +
        pad(d.getDate()) +
        " " +
        pad(d.getHours()) +
        ":" +
        pad(d.getMinutes()) +
        ":" +
        pad(d.getSeconds())
      );
    },
    onSearch() {
      this.page = 1;
      this.refresh();
    },
    async refresh() {
      this.loading = true;
      try {
        const res = await getUsers({
          page: this.page,
          pageSize: this.pageSize,
          keyword: this.keyword
        });
        const data = (res && res.data) || {};
        this.list = data.list || [];
        this.total = Number(data.total || 0);
      } catch (e) {
        this.$message.error("加载失败（需要 admin 权限）");
      } finally {
        this.loading = false;
      }
    },

    buildTree(list) {
      // list: [{orgId, orgName, cabinets:[{id,name,code}]}]
      const out = [];
      (list || []).forEach((g) => {
        const orgKey = "org-" + String(g.orgId);
        const orgNameRaw = g.orgName || (g.orgId ? "机构#" + g.orgId : "");
        const children =
          (g.cabinets || []).map((c) => ({
            key: "cab-" + String(c.id),
            id: Number(c.id),
            name: c.name,
            code: c.code,
            label: `${c.name}${c.code ? "（" + c.code + "）" : ""}`,
            orgName: orgNameRaw,
            isCabinet: true
          })) || [];
        out.push({
          key: orgKey,
          label: `${orgNameRaw}（${children.length}）`,
          orgName: orgNameRaw,
          isCabinet: false,
          children
        });
      });
      return out;
    },

    filterNode(value, data) {
      if (!value) return true;
      const v = String(value).toLowerCase();
      // 只按“机构名称”筛选：命中机构时显示其下所有柜子
      if (data && data.isCabinet) {
        return String(data.orgName || "")
          .toLowerCase()
          .includes(v);
      }
      return String((data && data.orgName) || data.label || "")
        .toLowerCase()
        .includes(v);
    },

    renderNode(h, { data }) {
      if (!data) return h("span");
      if (data.isCabinet) {
        return h("span", { class: "node" }, [
          h("span", { class: "node-title" }, data.name || data.label),
          data.code ? h("span", { class: "node-tag" }, String(data.code)) : null
        ]);
      }
      return h("span", { class: "node node-org" }, [h("span", { class: "node-title" }, data.label)]);
    },

    toggleExpand() {
      this.expandAll = !this.expandAll;
      // el-tree 的 default-expand-all 只在初始化生效，简单做法：强制重建树
      const old = this.treeData;
      this.treeData = [];
      this.$nextTick(() => {
        this.treeData = old;
      });
    },

    checkAll() {
      if (!this.$refs.treeRef) return;
      const keys = [];
      const walk = (arr) => {
        (arr || []).forEach((n) => {
          if (n.isCabinet) keys.push(n.key);
          if (n.children && n.children.length) walk(n.children);
        });
      };
      walk(this.treeData);
      this.$refs.treeRef.setCheckedKeys(keys);
    },

    clearChecked() {
      if (this.$refs.treeRef) this.$refs.treeRef.setCheckedKeys([]);
    },

    async openAssign(user) {
      this.currentUser = user;
      this.assignVisible = true;
      this.assignLoading = true;
      this.savingAssign = false;
      this.treeFilter = "";
      this.expandAll = true;

      try {
        const [treeRes, assignedRes] = await Promise.all([
          getCabinetTree(),
          getUserCabinetIds(user.id)
        ]);
        const groups = (treeRes && treeRes.data && treeRes.data.list) || [];
        this.treeData = this.buildTree(groups);

        const ids = (assignedRes && assignedRes.data && assignedRes.data.cabinetIds) || [];
        const keys = (ids || []).map((id) => "cab-" + String(id));

        this.$nextTick(() => {
          if (this.$refs.treeRef) this.$refs.treeRef.setCheckedKeys(keys);
        });
      } catch (e) {
        this.treeData = [];
        this.$message.error("加载柜子数据失败");
      } finally {
        this.assignLoading = false;
      }
    },

    async saveAssign() {
      if (!this.currentUser) return;
      const nodes = (this.$refs.treeRef && this.$refs.treeRef.getCheckedNodes(false, true)) || [];
      const cabinetIds = nodes.filter((n) => n && n.isCabinet).map((n) => n.id);

      this.savingAssign = true;
      try {
        await saveUserCabinets({ userId: this.currentUser.id, cabinetIds });
        this.$message.success("已保存");
        this.assignVisible = false;
      } catch (e) {
        this.$message.error("保存失败（需要 admin 权限）");
      } finally {
        this.savingAssign = false;
      }
    }
  }
};
</script>

<style scoped>
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.title {
  display: flex;
  align-items: center;
  font-weight: 600;
}
.actions {
  display: flex;
  align-items: center;
  gap: 8px;
}
.assign-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  color: #606266;
}
.assign-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}
.assign-footer-tip {
  margin-top: 10px;
  color: #606266;
}
.dot {
  margin: 0 8px;
  color: #c0c4cc;
}
.node {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}
.node-title {
  color: #303133;
}
.node-org .node-title {
  font-weight: 600;
}
.node-tag {
  font-size: 12px;
  padding: 2px 6px;
  border-radius: 999px;
  background: #f2f6fc;
  color: #409eff;
}
</style>

